export enum CouponButtonPosition {
    Fixed = 0,
    Static = 1
}